// Badge « Achat » / « Vente » à côté d'un numéro de pièce (A1b, 02/11/2026) :
// distingue une facture d'achat (numéro interne AC-…) d'une facture d'acompte
// de vente (AC…) ou d'une facture de vente (FA…).
export default function DocBadge({ kind }) {
  if (!["vente", "achat"].includes(kind)) return null;
  const sale = kind === "vente";
  return (
    <span title={sale ? "Facture de vente" : "Facture d'achat"} style={{ fontSize: 9.5, fontWeight: 700, padding: "1px 5px", borderRadius: 6, marginRight: 4, verticalAlign: "middle",
      background: sale ? "#dcfce7" : "#e0e7ff", color: sale ? "#166534" : "#3730a3" }}>{sale ? "Vente" : "Achat"}</span>
  );
}

/** Badge « Paiement saisi à la main » (ancienne action « Marquer payée ») */
export function ManualPaymentBadge() {
  return (
    <span title="Paiement saisi à la main (ancienne action « Marquer payée ») : vérifier qu'il n'est pas aussi relié au relevé (double 512)"
      style={{ fontSize: 9.5, fontWeight: 700, padding: "1px 5px", borderRadius: 6, marginLeft: 4, background: "#fef3c7", color: "#92400e" }}>Paiement saisi à la main</span>
  );
}
